import type { InteractiveItem } from "./items";

export type RowRole = "menuitem" | "menuitemcheckbox" | "menuitemradio";

export function rowRole(item: InteractiveItem): RowRole {
  if (item.kind === "checkbox") return "menuitemcheckbox";
  if (item.kind === "radio") return "menuitemradio";
  return "menuitem";
}

/** `aria-checked` of a row: only checkboxes and radios carry it. */
export function rowChecked(item: InteractiveItem): boolean | undefined {
  return item.kind === "checkbox" || item.kind === "radio" ? item.checked : undefined;
}

export function rowClassName(item: InteractiveItem): string {
  const danger = item.tone === "danger" ? " is-danger" : "";
  const selected = rowChecked(item) ? " is-selected" : "";
  return `nb-menu-item nb-ctx-item${danger}${selected}`;
}
